export const OPPORTUNITY_FORM_FIELDS = [
    {
        label: 'Opportunity Information',
        fields: [
            {
                settingFieldName: 'sequenceNumber',
                formFieldname: 'sequenceNumber'
            },
            {
                settingFieldName: 'name',
                formFieldname: 'name'
            },
            {
                settingFieldName: 'activeInactiveStatus',
                formFieldname: 'activeInactiveStatus'
            },
            {
                settingFieldName: 'description',
                formFieldname: 'description'
            },
            {
                settingFieldName: 'accountName',
                formFieldname: 'accountId'
            },
            {
                settingFieldName: 'owner',
                formFieldname: 'ownerId'
            },
            {
                settingFieldName: 'contactName',
                formFieldname: 'contactName'
            },
            {
                settingFieldName: 'contactMobileNo',
                formFieldname: 'contactMobileNo'
            },
            {
                settingFieldName: 'contactEmailAddress',
                formFieldname: 'contactEmailAddress'
            },
            {
                settingFieldName: 'quality',
                formFieldname: 'ratingId'
            },
            {
                settingFieldName: 'sourceName',
                formFieldname: 'sourceId'
            },
            {
                settingFieldName: 'probability',
                formFieldname: 'probability'
            },
            {
                settingFieldName: 'stageName',
                formFieldname: 'opportunityStageId'
            },
            {
                settingFieldName: 'forcastCategory',
                formFieldname: 'forcastCategory'
            },
            {
                settingFieldName: 'expectedDate',
                formFieldname: 'expectedDate'
            },
            {
                settingFieldName: 'repConfidence',
                formFieldname: 'repConfidence'
            },
            {
                settingFieldName: 'totalAmount',
                formFieldname: 'totalAmount'
            }
        ]
    },
    {
        label: 'Selected Products',
        fields: [
            {
                settingFieldName: 'productName',
                formFieldname: 'itemNo'
            },
            {
                settingFieldName: 'productDescription',
                formFieldname: 'productDescription'
            },
            {
                settingFieldName: 'uom',
                formFieldname: 'uom'
            },
            {
                settingFieldName: 'unit',
                formFieldname: 'unit'
            },
            {
                settingFieldName: 'unit',
                formFieldname: 'qty'
            },
            {
                settingFieldName: 'price',
                formFieldname: 'price'
            },
            {
                settingFieldName: 'itemTotal',
                formFieldname: 'itemTotal'
            },
            {
                settingFieldName: 'subTotal',
                formFieldname: 'subTotal'
            },
            {
                settingFieldName: 'productDiscount',
                formFieldname: 'productDiscount'
            },
            {
                settingFieldName: 'productDiscountType',
                formFieldname: 'productDiscountType'
            },
            {
                settingFieldName: 'productHandlingFees',
                formFieldname: 'productHandlingFees'
            },
            {
                settingFieldName: 'tax',
                formFieldname: 'tax'
            },
            {
                settingFieldName: 'additionalDiscount',
                formFieldname: 'additionalDiscount'
            },
            {
                settingFieldName: 'taxAmount',
                formFieldname: 'taxAmount'
            },
            {
                settingFieldName: 'shipping',
                formFieldname: 'shipping'
            },
            // {
            //     settingFieldName: 'totalAmount',
            //     formFieldname: 'totalAmount'
            // }
        ]
    }
]
